import React from 'react'

export const BkFlowCheckbox = ({ input, name, label, type, size, labelClasses, labelLink, labelLinkText, required, meta: { touched, error } }) => (
  <div className={ type === 'checkbox' ? 'u-form-col u-form-col--inline u-form-col--' + size : 'u-form-col u-form-col--' + size}>
    <input
      { ...input }
      type={ type }
      aria-labelledby={ input.name + 'Label' }
      required={required}
      aria-required={required ? true : false}
    />

    <label
      id={ input.name + 'Label' }
      className={ labelClasses  ? labelClasses : 'u-form-label u-remove-margin' }
      htmlFor={ input.name }
    >
      { required && '*' }
      { label }

      { labelLink &&
        <span
          className='u-form-label-link u-font-small'
          onClick={ () => window.open(labelLink) }
        >
					{ labelLinkText }
				</span>
      }
    </label>

    { touched && ((error && <p className="u-font-error" aria-live="assertive">{error}</p>)) }
  </div>
)



// WEBPACK FOOTER //
// ./src/components/forms/elements/BkFlowCheckbox.js